import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import usePageScale from 'components/business/usePageScale';
import CookieConsent from 'components/CookieConsent';

/**
 * The shell for a page served WITHOUT the site's chrome: no header, no
 * footer, no section menus — a campaign page that stands on its own
 * (/phone-agent). It keeps the two things every page needs whichever shell
 * it is in: the viewport scale the .biz-page layouts read (--biz-zoom, as
 * Layout sets it), and the cookie consent sheet, which is what lets the
 * analytics scripts load at all. The first page view is sent by the gtag
 * config in public/index.html; route changes do not happen under this
 * shell, so nothing else is reported here.
 */
const BareLayout = () => {
    usePageScale();
    return (
        <>
            <Suspense fallback={<div style={{ minHeight: '100vh' }} aria-busy='true' />}>
                <Outlet />
            </Suspense>
            <CookieConsent />
        </>
    );
};

export default BareLayout;
